import React from "react";
import Userspages from "../../Components/DashBoard/userspage";
function UsersPage() {
  return <Userspages />;
}

export default UsersPage;
